'use client'

import { Tag } from '@circlefin/components/lib/Tag'

export const CWTag = Tag
